import React, {useEffect, useState} from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import axios from "axios";
import {useParams} from "react-router-dom";
import {Button, Modal, Spin} from "antd";
import {CAM_PATH} from "../../../components/const";
const ListLibraryExport = () => {
    const [loader, setLoader] = useState(false)
    const [data, setData] = useState([])
    const [isModalOpen, setiIModalOpen] = useState(false)
    const [selectId, setSelectId] = useState("")
    const [selectType, setSelectType] = useState(null)

    let params = useParams()
    const Pass = localStorage.getItem("smartPass")
    const getData = () => {
      axios.post(CAM_PATH + "device/" + params.id + "/user_management/queryTheUserListInformation?search_str=asdasdasdsd",
          {password: Pass,
          start: 0,
          length: 0}
          ,{ auth: {
              username: 'admin',
              password: "ping1234"
          }})
          .then(res =>{
              setData(res?.data?.user_id_list)
          })

    }
    console.log(getData)
    // "user_list": 2 white list
    // "user_list": 1 black list
    const onDelete = () => {
        setLoader(true)

        axios.post(CAM_PATH + "device/" + params.id + "/user_management/deleteUser",
            {
                password: Pass,
                user_id: selectId,
                user_list: 1
            }
            ,{ auth: {
                    username: 'admin',
                    password: "ping1234"
                }})
            .then(() =>{
               getData()
                setiIModalOpen(false)
                setLoader(false)
            })
            .catch(() =>{
                getData()
                setLoader(false)

            })
        axios.post(CAM_PATH + "device/" + params.id + "/user_management/deleteUser",
            {
                password: Pass,
                user_id: selectId,
                user_list: 2
            }
            ,{ auth: {
                    username: 'admin',
                    password: "ping1234"
                }})
            .then(() =>{
               // getData()
                setiIModalOpen(false)
                setLoader(false)
            })
            .catch(() =>{
                // getData()
                setLoader(false)

            })
    }

    const onDeleteBlackList = () => {
        setLoader(true)

        axios.post(CAM_PATH + "device/" + params.id + "/user_management/deleteUserList",
            {
                password: Pass,
                user_list: selectType
            }
            ,{ auth: {
                    username: 'admin',
                    password: "ping1234"
                }})
            .then(() =>{
                getData()
                setiIModalOpen(false)
                setLoader(false)

            })
            .catch(() =>{
                getData()
                setLoader(false)

            })
    }
    useEffect(() => {
        getData()
        // setSelectId("")
    }, []);
    return (
        <div className="main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>List Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Face Library Export</span>
            </div>
            <div className="camera-config-content">
                <div className="control-header-cmcf my-avform">
                   <div className="d-flex">
                       <div className="input-group mb-3" style={{width: "220px", height: "36px"}}>
                           <input type="text" className="form-control h-100" placeholder="Enter username" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                           <div className="input-group-append h-100">
                               <button className="btn btn-primary h-100   " style={{borderRadius: "0 6px 6px 0"}} type="button">
                                   <img src="/icon/loupe.png" className="w-75" style={{marginTop: "-5px"}} alt="..."/>
                               </button>
                           </div>
                       </div>
                       <div className="input-group mb-3 ml-24" style={{width: "220px", height: "36px"}}>
                           <input type="text" className="form-control h-100" placeholder="ID" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                           <div className="input-group-append h-100">
                               <button className="btn btn-primary h-100   " style={{borderRadius: "0 6px 6px 0"}} type="button">
                                   <img src="/icon/loupe.png" className="w-75" style={{marginTop: "-5px"}} alt="..."/>
                               </button>
                           </div>
                       </div>
                       <div style={{height: "36px"}}>
                           <button className="btn btn-primary ml-24 mr-24">Export ZIP</button>
                           <div className="btn-group">
                               {/*<button className="btn btn-danger"> Delete selected user information </button>*/}
                               <button className="btn btn-danger" style={{marginLeft: "1px"}}>Delete all</button>
                               <button className="btn btn-danger" style={{marginLeft: "1px"}} onClick={() => {
                                   setiIModalOpen(true)
                                   setSelectType(2)
                               }}>Delete all white list</button>
                               <button className="btn btn-danger" style={{marginLeft: "1px"}} onClick={() => {
                                   setiIModalOpen(true)
                                   setSelectType(1)
                               }}>Delete all black list</button>
                           </div>
                       </div>
                   </div>
                </div>
                <div className="emp-table">
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="pl20 table-head" align="left">ID</TableCell>
                                    <TableCell className="table-head" align="left">name</TableCell>
                                    <TableCell className="pr20 table-head" align="right">
                                        Действие
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data?.map((item, index) =>(
                                        <TableRow
                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                        >
                                            <TableCell className="pl20 text-white" component="th" scope="row">
                                                {index + 1}
                                            </TableCell>
                                            <TableCell className="text-white" align="left">{item?.user_id}</TableCell>
                                            <TableCell className="text-white" align="right"><button className="btn p-0" onClick={() => {
                                                setiIModalOpen(true)
                                                setSelectType(null)
                                                setSelectId(item?.user_id)
                                            }}>
                                                <img src="/icon/deletefill.svg" alt=""/>
                                            </button></TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            {
                isModalOpen
                    ?
                    <Modal title="Внимание!"
                           open={isModalOpen}
                           onCancel={() => setiIModalOpen(false)}
                           footer={[
                               <Button key="submit" type="default" onClick={(() => setiIModalOpen(false))}>
                                   Отменить
                               </Button>,
                               <Button key="submit" type="danger"  className="my-red-canc"  onClick={selectType === 1 || selectType === 2 ? onDeleteBlackList : onDelete}>
                                   Удалить
                               </Button>
                           ]}
                    >

                        <div className="inputs-box">
                            <label className="font-family-medium mt-2"> Вы уверены, что хотите {selectType  === 1 ? "black list" : selectType === 2 ? "white list" : ""} удалить?</label>
                        </div>
                    </Modal>
                        :
                    ""
            }
            {
                loader
                    ?

                    <div className="my-loader">
                        <Spin size="large" />
                    </div>
                    :
                    ""
            }
        </div>
    );
};

export default ListLibraryExport;